module.exports = __webpack_public_path__ + "img/achievementDetailsBj.b2672830.png";